export default (function (_ref) {
  var request = _ref.request;
  return {
    deviceItemAdd: function deviceItemAdd(data) {
      return request({
        url: '/iot/deviceItem',
        method: 'post',
        data: data
      });
    },
    deviceItemModify: function deviceItemModify(data) {
      return request({
        url: "/iot/deviceItem/".concat(data.id),
        method: 'put',
        data: data
      });
    },
    deviceItemDel: function deviceItemDel(id) {
      return request({
        url: "/iot/deviceItem/".concat(id),
        method: 'delete'
      });
    },
    deviceItemQuery: function deviceItemQuery(data) {
      return request({
        url: '/iot/deviceItem',
        method: 'get',
        params: data
      });
    },
    deviceItemQueryCache: function deviceItemQueryCache(deviceId, data) {
      return request({
        url: "/iot/deviceItem/cache/".concat(deviceId),
        method: 'get',
        params: data
      });
    },
    deviceItemLastRecordQuery: function deviceItemLastRecordQuery(deviceId) {
      return request({
        url: "/iot/deviceItem/".concat(deviceId, "/lastRecord"),
        method: 'get'
      });
    },
    deviceItemDetail: function deviceItemDetail(id) {
      return request({
        url: "/iot/deviceItem/".concat(id),
        method: 'get'
      });
    }
  };
});